

const paketlemeTypes = [
    {
        id: 1,
        name: "Palet",
    },
    {
        id:2,
        name: "Kutu",
    },
    {
        id: 3,
        name: "Dökme",
    },

    {
        id: 4,
        name: "Big Bag",
    },
    {
        id: 5,
        name: "Varil Bidon",
    },
    {
        id: 6,
        name: "Teneke",
    },
    {
        id: 7,
        name: "IBC",
    },
    {
        id: 0,
        name: "Diğer",
    },
]

export default paketlemeTypes